import { AudioAssetProps } from '@ahc-digital/component-library';
import { C18AudioAssetProps } from './C18AudioAsset.types';
import { getDroplink } from 'src/shared/param-utils';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';

export function CreateAudioAssetModel(props?: C18AudioAssetProps): AudioAssetProps {
  const { fields, params } = props || {};

  const { renderRichText } = useConditionalRendering();

  return {
    audioSrc: fields?.Audio?.value?.src || '',
    caption: renderRichText(fields?.Caption),
    captionPlacement: getDroplink(params?.CaptionPlacement, 'top'),
    playerAlignment: getDroplink(params?.PlayerAlignment, 'left'),
  };
}
